import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class AddArbetsorderIntressentCommand extends BasicCommand<AddArbetsorderIntressentCommand> {
    get primaryKey(): IPrimaryKey<AddArbetsorderIntressentCommand> {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Arbetsorder";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "AddArbetsorderIntressentCommand";
    constructor(init: (instance: AddArbetsorderIntressentCommand) => void) {
        super(AddArbetsorderIntressentCommand.$type, AddArbetsorderIntressentCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
